import { css } from '@emotion/css';
import {
  Card,
  CardMedia,
  Divider,
  Tooltip,
  Typography,
} from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import {
  Apartmen as ApartmenIcon,
  Apartment,
  ChevronLeft,
  Language,
  Link as LinkIcon,
  Pinterest,
  QuestionAnswer as QuestionAnswerIcon,
  Room as RoomIcon,
  Send as SendIcon,
  Edit as EditIcon,
  Mail,
  Phone,
  Twitter,
  YouTube,
} from '@material-ui/icons';
import X from 'components/Icons/X';
import {
  connectABusinessPartner,
  getInfosAccountRestricted,
  getSchoolsPartners,
  getStudentAffiliate,
} from '@webapps/business';
import {
  Modal,
  useAuth,
  useMutation,
  useQuery,
  useRouter,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Facebook from 'assets/facebook';
import Instagram from 'assets/instagram';
import LinkedIn from 'assets/linkedin';
import Tiktok from 'assets/tiktok';
import Partenaire from 'components/Icons/Partenaire';
import VerifiedIcon from 'components/Icons/VerifiedIcon';
import { ROUTES_PATH } from 'config/constants';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import MessageBox from 'components/MessageBox';

import theme from '../theme';
import Information from 'components/Icons/Information';
import { formatPhoneNumber } from 'react-phone-number-input';

const {
  colors: { background },
} = theme;

const ProfilName = ({
  city,
  sector,
  coverImage,
  location,
  cp,
  name,
  owner,
  profileImage,
  slogan,
  // verified,
  website,
  pinterest,
  twitter,
  linkedin,
  facebook,
  youtube,
  tiktok,
  instagram,
  phone,
  email,
  partners,
}) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser, profile } = useAuth();

  const { params } = useRouter();

  const { id: idParam } = params;

  const history = useHistory();

  const handleEditVitrine = () => {
    history.push(ROUTES_PATH.EDIT_Business_VITRINE);
  };

  const [openMessageBox, setOpenMessageBox] = useState(false);

  const LightTooltip = withStyles(({ shadows }) => ({
    tooltip: {
      backgroundColor: '#5D75A8',
      color: '#FFF',
      boxShadow: shadows[1],
      '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
      '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
      fontWeight: 600,
    },
  }))(Tooltip);

  const {
    isLoading: isLoadingConnect,
    isSuccess: isSuccessConnect,
    mutateAsync: mutateConnect,
  } = useMutation(connectABusinessPartner);

  const reqPartner = async () => {
    await mutateConnect({
      data: {
        schoolId: idUser,
        businessId: idParam,
      },
    });
  };

  const { data: { content: partnersAccepted = [] } = {}, refetch: refetchAccepted } = useQuery(
    getSchoolsPartners,
    {
      key: ['schoolsPartnersAccepted', idUser],
      variables: {
        id: idUser,
        type: 'accepted',
        page: 0,
        size: 10,
      },
      keepPreviousData: true,
      staleTime: 5000,
      enabled: profile === 'SCHOOL',
    }
  );

  const { data: { content: partnersRequested = [] } = {}, refetch: refetchRequested } = useQuery(
    getSchoolsPartners,
    {
      key: ['schoolsPartnersRequested', idUser],
      variables: {
        id: idUser,
        type: 'requested',
        page: 0,
        size: 10,
      },
      keepPreviousData: true,
      staleTime: 5000,
      enabled: profile === 'SCHOOL',
    }
  );

  const { data: { content: partnersReceived = [] } = {}, refetch: refetchReceived } = useQuery(
    getSchoolsPartners,
    {
      key: ['schoolsPartnersReceived', idUser],
      variables: {
        id: idUser,
        type: 'received',
        page: 0,
        size: 10,
      },
      keepPreviousData: true,
      staleTime: 5000,
      enabled: profile === 'SCHOOL',
    }
  );

  const { data: infoAccount = [] } = useQuery(getInfosAccountRestricted, {
    key: ['vitrineInfoAccount', params.id],
    variables: { id: params.id },
  });

  const {
    data: { data: affiliations = [] } = {},

    isLoading: isLoadingAffiliation,
  } = useQuery(getStudentAffiliate, {
    key: ['studentAffiliateDashboardAccepted', idUser],
    variables: { id: idUser, type: 'school', status: 'ENCLOSED' },
    enabled: profile === 'INDIVIDUAL',
  });

  const handleRefetch = () => {
    refetchAccepted();
    refetchRequested();
    refetchReceived();
  }

  const hasNotSocial =
    !facebook &&
    !instagram &&
    !tiktok &&
    !youtube &&
    !pinterest &&
    !twitter &&
    !linkedin;

  const isTruncated = sector?.length > 22;
  const sectorText = isTruncated ? `${sector.slice(0, 22)}...` : sector;

  const { addToast } = useToast();

  useEffect(() => {
    if (isSuccessConnect) {
      addToast({
        status: 'success',
        message: 'Demande envoyée',
      });
    }
    handleRefetch();
  }, [isSuccessConnect]);

  const copyUrl = (e) => {
    let url = window.location.href;
    e.value = url;
    navigator.clipboard
      .writeText(e.value)
      .then(() => {
        addToast({
          status: 'success',
          message: 'Lien copié',
        });
      })
      .catch(() => {
        addToast({
          status: 'error',
          message: 'Erreur lors de la copie ',
        });
      });
  };

  return (
    <div className={css({width: '100%'})}>
      {!owner && (
        <Button
          className={classes.topReturnButton}
          onClick={() => history.goBack()}
          startIcon={<ChevronLeft />}
          >
          Retour
        </Button>
      )}
      <Grid className={classes.profilContainer}>
        <Grid
          className={css({
            height: 'fit-content',
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            '@media screen and (max-width: 768px)': {
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
            },
          })}
          xs={12}
        >
          <Paper
            className={css({
              height: 'fit-content',
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              '@media screen and (max-width: 768px)': {
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
              },
            })}
            elevation={0}
          >
            <Card
              className={css({
                position: 'relative',
                height: 'fit-content',
                borderTopLeftRadius: 10,
                borderTopRightRadius: 10,
                '@media screen and (max-width: 768px)': {
                  borderTopLeftRadius: 0,
                  borderTopRightRadius: 0,
                },
              })}
              classes={{
                root: css({
                  overflow: 'visible',
                }),
              }}
              elevation={0}
            >
              {coverImage ? (
                <CardMedia
                  component="img"
                  alt="cover image"
                  image={coverImage}
                  className={css({
                    borderTopLeftRadius: 10,
                    borderTopRightRadius: 10,
                    '@media screen and (max-width: 768px)': {
                      borderTopLeftRadius: 0,
                      borderTopRightRadius: 0,
                    },
                  })}
                /> ) : (
                  <div
                    className={cx(
                      classes.title,
                      css({
                        background: '#0060F9',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                      })
                    )}
                  ></div>
                )}
                {profileImage ? (
                  <Avatar className={classes.avatar} src={profileImage} />
                ) : (
                  <Avatar className={classes.avatar}>
                    {name?.substr(0, 1)}
                  </Avatar>
                )}
            </Card>
          </Paper>
        </Grid>
        <Grid
          className={css({
            display: 'flex',
            marginLeft: '20px',
            flexDirection: 'column',
            '@media screen and (max-width: 768px)': {
              marginLeft: 20,
            },
          })}
          xs={12}
        >
          <div
            className={css({
              position: 'relative',
              marginTop: '-50px',
              '@media screen and (max-width: 768px)': {
                marginTop: '-15px',
              },
            })}
          ></div>
          <div
            className={css({
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              marginTop: '110px',
              '@media screen and (max-width: 768px)': {
                marginTop: '60px',
              },
            })}
            >
            <div className={cx(classes.name, global.title)}>
              {name}
              <div
                className={css({
                  marginLeft: spacing(1),
                })}
              >
                <VerifiedIcon color={'#1DA1F2'} className={global.smallIcon} />
              </div>
            </div>
            <div className={cx(classes.slogan, global.infoText)}>
              <p>{slogan || "Aucun slogan"}</p>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                columnGap: '20px',
                justifyContent: 'flex-start',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <RoomIcon className={global.infoIcon} />
                <LightTooltip title={location} placement="top">
                  <Typography className={global.infoText}>
                    {cp}, {city}
                  </Typography>
                </LightTooltip>
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Apartment className={global.infoIcon} />
                {isTruncated ? (
                  <LightTooltip title={sector} placement="top">
                    <Typography className={global.infoText}>
                      {sectorText}
                    </Typography>
                  </LightTooltip>
                ) : (
                  <Typography className={global.infoText}>
                    {sectorText}
                  </Typography>
                )}
              </div>
            </div>
            {affiliations.length > 0 && partners.length > 0 && partners.find(({ id }) => id === affiliations[0]?.classroom?.school?.id) && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  columnGap: '20px',
                  justifyContent: 'flex-start',
                  marginTop: '10px'
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Phone className={global.infoIcon} />
                  <Typography className={global.infoText}>
                  {phone ? formatPhoneNumber(phone) : 'Non renseigné'}
                  </Typography>
                </div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Mail className={global.infoIcon} />
                  <Typography className={global.infoText}>
                    {email}
                  </Typography>
                </div>
              </div>
            )}
            <Grid
              container
              justifyContent="flex-start"
              alignItems="center"
              style={{
                marginTop: '20px',
                marginBottom: '20px',
                flexWrap: 'wrap',
                gap: '10px',
              }}
              spacing={1}
            >
              <Grid>
                {!owner &&
                  profile === 'SCHOOL' &&
                  infoAccount?.subscription &&
                  infoAccount?.subscription.toLowerCase() == 'premium' &&
                  !partnersAccepted.find(({ id }) => id === idParam) &&
                  !partnersRequested.find(({ id }) => id === idParam) &&
                  !partnersReceived.find(({ id }) => id === idParam) && (
                    <Button
                      className={[classes.button, css({borderRadius: 10})]}
                      disabled={isLoadingConnect}
                      startIcon={<Partenaire color="white" />}
                      onClick={reqPartner}
                      variant="outlined"
                      
                    >
                      Demander un partenariat
                    </Button>
                  )}
                {!owner &&
                  profile === 'SCHOOL' &&
                  infoAccount?.subscription &&
                  infoAccount?.subscription.toLowerCase() == 'free' &&
                  !partnersAccepted.find(({ id }) => id === idParam) &&
                  !partnersRequested.find(({ id }) => id === idParam) &&
                  !partnersReceived.find(({ id }) => id === idParam) && (
                    <LightTooltip
                      title="Vous ne pouvez pas ajouter un partenaire ayant un compte gratuit 🔒"
                      placement="top"
                    >
                      <div>
                        <Button
                          className={[classes.button, css({borderRadius: 10})]}
                          disabled
                          startIcon={<Partenaire color="white" />}
                          fullWidth
                          variant="outlined"
                        >
                          Demander un partenariat
                        </Button>
                      </div>
                    </LightTooltip>
                  )}
                {!owner &&
                  profile === 'INDIVIDUAL' &&
                  infoAccount?.subscription &&
                  infoAccount?.subscription.toLowerCase() == 'premium' &&
                  !partnersAccepted.find(({ id }) => id === idParam) &&
                  !partnersRequested.find(({ id }) => id === idParam) &&
                  !partnersReceived.find(({ id }) => id === idParam) && (
                    <Button
                    className={`${classes.button} ${css({display: "none"})}`}
                      disabled={isLoadingConnect}
                      fullWidth
                      startIcon={<SendIcon />}
                      onClick={() => {
                        // console.log('à coder !');
                      }}
                      variant="outlined"
                    >
                      Candidature spontanée
                    </Button>
                  )}
                {owner === true && (
                  <Button
                    className={classes.returnButton}
                    fullWidth
                    onClick={handleEditVitrine}
                    startIcon={<EditIcon />}
                    >
                    Modifier ma vitrine
                  </Button>
                )}
                {!owner &&
                  profile === 'SCHOOL' &&
                  partnersAccepted.find(({ id }) => id === idParam) && (
                    <Button
                      className={[classes.button, css({borderRadius: 10})]}
                      startIcon={<Partenaire color="white" />}
                      disabled
                      fullWidth
                      color="primary"
                      variant="outlined"
                    >
                      Partenariat en cours
                    </Button>
                  )}

                {!owner &&
                  profile === 'SCHOOL' &&
                  (partnersRequested.find(({ id }) => id === idParam) ||
                  partnersReceived.find(({ id }) => id === idParam)) && (
                    <Button
                      className={[classes.button, css({borderRadius: 10})]}
                      startIcon={<Partenaire color="white" />}
                      disabled
                      fullWidth
                      variant="outlined"
                    >
                      Demande en attente
                    </Button>
                  )}
              </Grid>
              <Grid xs={4}>
                {!owner && (
                  <Button
                    variant="outlined"
                    startIcon={<QuestionAnswerIcon />}
                    fullWidth
                    className={css({
                      borderColor: '#0060F9',
                      color: '#0060F9',
                      borderRadius: '6px',
                      padding: '0px 30px 0px 30px',
                      fontWeight: 600,
                      '&:hover': {
                        borderColor: '#0060F9',
                      },
                    })}
                    onClick={() => setOpenMessageBox(true)}
                  >
                    Contacter
                  </Button>
                )}
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
      <Grid
        className={css({
          display: hasNotSocial ? 'none' : 'block',
          borderRadius: 10,
          marginTop: 25,
          padding: 20,
          backgroundColor: 'white',
          flexDirection: 'column',
        })}
        xs={12}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div className={cx(global.title, classes.infoTitle)}>
            Nos réseaux et liens
          </div>
          <div
            className={css({
              marginTop: '20px',
              display: 'flex',
              width: '100%',
            })}
          >
            {/* SOCIAL MEDIA START */}
            <div className={classes.iconsDesktop}>
              {youtube && (
                <LightTooltip title={'Youtube'} placement="top">
                  <a
                    href={youtube}
                    target={'_blank'}
                    className={classes.socialIcons}
                  >
                    <YouTube />
                  </a>
                </LightTooltip>
              )}
              {instagram && (
                <LightTooltip title={'Instagram'} placement="top">
                  <a
                    href={instagram}
                    target={'_blank'}
                    className={classes.socialIcons}
                  >
                    <Instagram />
                  </a>
                </LightTooltip>
              )}
              {linkedin && (
                <LightTooltip title={'LinkedIn'} placement="top">
                  <a
                    href={linkedin}
                    target={'_blank'}
                    className={classes.socialIcons}
                  >
                    <LinkedIn />
                  </a>
                </LightTooltip>
              )}
              {facebook && (
                <LightTooltip title={'Facebook'} placement="top">
                  <a
                    href={facebook}
                    target={'_blank'}
                    className={classes.socialIcons}
                  >
                    <Facebook />
                  </a>
                </LightTooltip>
              )}
              {pinterest && (
                <LightTooltip title={'Pinterest'} placement="top">
                  <a
                    href={pinterest}
                    target={'_blank'}
                    className={classes.socialIcons}
                  >
                    <Pinterest />
                  </a>
                </LightTooltip>
              )}
              {twitter && (
                <LightTooltip title={'X'} placement="top">
                  <a
                    href={twitter}
                    target={'_blank'}
                    className={classes.socialIcons}
                  >
                    <X />
                  </a>
                </LightTooltip>
              )}
              {tiktok && (
                <LightTooltip title={'Tiktok'} placement="top">
                  <a
                    href={tiktok}
                    target={'_blank'}
                    className={classes.socialIcons}
                  >
                    <Tiktok />
                  </a>
                </LightTooltip>
              )}
              {website && (
                <LightTooltip title={'Site web'} placement="top">
                  <a
                    href={
                      website.includes('http')
                        ? `${website}`
                        : `http://${website}`
                    }
                    target={'_blank'}
                    className={classes.socialIcons}
                  >
                  <Language />
                  </a>
                </LightTooltip>
              )}
              <LightTooltip
                title={'Copier le lien vers la vitrine'}
                placement="top"
              >
                <a
                  className={classes.socialIcons}
                  onClick={copyUrl}
                >
                  <LinkIcon style={{ color: '#5A6DA1' }} />
                </a>
              </LightTooltip>
            </div>
          </div>
        </div>
      </Grid>
      <Modal
        onCancel={() => setOpenMessageBox(false)}
        open={openMessageBox}
        // subTitle="Envoyez un message aux candidats et gardez contact dans votre
        // messagerie"
        title="Envoyer un message"
        withStep={false}
      >
        <div className={css({display: 'flex', flexDirection: 'row'})}>
          <span>
          <Information className={css({color:'#0060F9', height: 20, width: 20, marginRight: 10})}/>
          </span>
          <div className={css({fontSize: 14, color:'rgba(0, 0, 0, 0.87)'})}>
            Envoyez un message à l'entreprise et gardez contact dans votre messagerie
          </div>
        </div>
        <MessageBox id={idParam} onCancel={() => setOpenMessageBox(false)}/>
      </Modal>
    </div>
  );
};

const styles = ({ spacing }) => ({
  profilContainer: {
    backgroundColor: 'white',
    borderRadius: 20,
  },
  socialIcons: {
    padding: spacing(1),
    margin: 3,
    borderRadius: '5px',
    border: '1px solid #C0D9FF',
    backgroundColor: '#F3F7FF',
    width: '36px',
    display: 'flex',
    justifyContent: 'center',
    height: '36px',
    alignItems: 'center',
    cursor:'pointer',
    pointerEvents: 'auto',
    color: '#5A6DA1',
  },
  title: {
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    height: '15vh',
    width: '100%',
    position: 'relative',
    '@media only screen and (max-width:1500px)': {
      height: '30vh',
    },
    '@media only screen and (max-width:1300px)': {
      height: '25vh',
    },
    '@media only screen and (max-width:1050px)': {
      height: '18vh',
    },
    '@media only screen and (max-width:850px)': {
      height: '15vh',
    },
    '@media only screen and (max-width:650px)': {
      height: '12vh',
    },
    '@media only screen and (max-width:500px)': {
      height: '10vh',
    },
  },
  avatar: {
    height: 80,
    width: 80,
    background: '#5A6DA1',
    position: 'absolute',
    bottom: -40,
    left: 30,
  },
  nameContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  name: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Montserrat',
  },
  slogan: {
    marginTop: '0px',
    width: '90%',
    display: 'flex',
    alignItems: 'center',
    lineHeight: '20px',
  },
  gridBtn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  iconsDesktop: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    marginTop: '-10px',
    gap: '10px',
    '@media screen and (max-width: 1600px)': {
      gap: '5px',
    },
  },
  iconsMobile: {
    '@media screen and (min-width: 769px)': {
      display: 'none',
    },
  },
  infoTitle: {
    borderLeft: '3px solid #0060F9',
    paddingLeft: 8,
    fontWeight: 600,
  }, 
  button: {
    whiteSpace: 'nowrap',
    minWidth: 'auto',
    borderRadius: '10.00px',
    color: 'white',
    backgroundColor: '#0060F9',
    '&.MuiButton-outlined.Mui-disabled': {
      backgroundColor: '#F3F7FF',
      color: '#5D75A8',
      '& .MuiSvgIcon-root': {
        color: '#5D75A8',
      },
      border: '1px solid #C0D9FF',
    },
    '& .MuiSvgIcon-root': {
      color: 'white',
    },
    '&:hover': {
      backgroundColor: '#003b99',
    },
  },
  returnButton: {
    color: '#5A6DA1',
    border: '1px solid #C0D9FF',
    backgroundColor: '#F3F7FF',
    padding: '0px 20px 0px 20px',
    borderRadius: '6px',
  },
  topReturnButton: {
    color: '#5A6DA1',
    border: '1px solid #C0D9FF',
    padding: '0px 20px 0px 20px',
    backgroundColor: 'white', 
    borderRadius: 50, 
    marginBottom: 20,
    '@media screen and (max-width: 768px)': {
      marginTop: 20,
      marginLeft: 20,
    },
  }
});

ProfilName.propTypes = {
  city: PropTypes.string,
  cp: PropTypes.string,
  name: PropTypes.string,
  coverImage: PropTypes.string,
  profileImage: PropTypes.string,
  website: PropTypes.string,
  owner: PropTypes.bool,
};

export default ProfilName;
